export const NAME = 'groups';
export const LEVEL_ONE = 'GroupsComponentReducer';
